import React from "react";
import Container from "../../atoms/Container";
import HeaderRating from "../../atoms/HeaderRating";
import { useHeaderSettings } from "../../../hooks/useHeaderSettings";
import { Link } from "gatsby";
import HeaderNotice from "../../atoms/HeaderNotice/headerNotice";

export default function MiniHeader({subHandler}) {

    const headerSettings = useHeaderSettings()
    const miniMenu = headerSettings.wpMenu.menuItems.nodes

    return (
        <>
        {headerSettings.wp.acfOptionsHeader.header.toonNotice ? <HeaderNotice data={headerSettings.wp.acfOptionsHeader.header} /> : null}
        <div className="hq-header__mini" onMouseEnter={() => { subHandler(undefined) }}>
            <Container styles={'flex justify-between'}>
                <HeaderRating />
                <div className="hq-header__mini--menu">
                    <nav>
                        <ul>
                            {miniMenu.map((m, i) => {
                                return (
                                    <li key={i}><Link to={m.uri}>{m.label}</Link></li>
                                )
                            })}
                        </ul>
                    </nav>
                </div>
            </Container>
        </div>
        </>
    )
}